import '../team/team.css'
import { useParams, useLocation } from 'react-router-dom';
import CampaignTable from '../../components/campaigns/CampaignTable';
import CampaignUserTable from '../../components/users/CampaignUserTable';
import FallbackUserTable from '../../components/users/FallbackUserTable';
import { useSelector } from 'react-redux'
// import CampaignTable from '../../components/campaigns/CampaignTable';
import adminLogo from '../../Images/admin_img.jpg'

const Wrapper = () => {
  const location = useLocation();
  const { campaignId } = useParams();
  // const {userId} = useParams();
  const isSuperuser = useSelector((state) => state.user.isSuperuser);
  const image = useSelector((state) => state.user.image);

  return(
    <>
      <div 
            className='table-container' 
            style={{
            paddingBottom: '2rem',
            backgroundImage: `url("${isSuperuser ? adminLogo : image}")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            minHeight: '90vh',
            position: 'relative' // Needed for overlay positioning
            }}
        >
            <div
            className='table-inner-div'
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 0 // Below content
            }}
            />
      { campaignId ? (
        location.pathname.includes('campaign_users') ?
        <CampaignUserTable />:
        <FallbackUserTable />
        )
       : 
        <CampaignTable />
      }
      </div>
    </>
  );
}
export default Wrapper;
